import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

/** Первый показанный месяц. */
export const selectCurrentDate = createSelector(
  (state: RootState) => state.schedule.currentMonth,
  (state: RootState) => state.schedule.currentYear,
  (month, year) => ({ month, year }),
);

export const selectSelectedDate = (state: RootState) => state.schedule.selectedDate;

export const selectChampionshipFilter = (state: RootState) => state.schedule.championshipFilter;
